module.exports = __webpack_public_path__ + "static/products_nginr-8746dd10f57e7b8f4bad05ad140b38fc.png";